<template>
  <div>
    <el-form class="lesson-form" ref="form" label-width="100px">
      <el-form-item label="标题">
        <el-input v-model="form.title" placeholder="要覆盖默认标题请写在这里"></el-input>
      </el-form-item>
      <el-form-item label="简介">
        <el-input type="textarea" v-model="form.intro" :autosize="{minRows:2}" resize="none"></el-input>
      </el-form-item>
      <el-form-item label="说明">
        <el-input type="textarea" v-model="form.tips" :autosize="{minRows:2}" resize="none"></el-input>
      </el-form-item>
      <el-form-item label="有效">
        <el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'LessonUnitForm',
  props: {
    lid: Number
  },
  data () {
    return {
      form: {
        id: null,
        lid: this.lid,
        type: 'study',
        num: 0,
        title: '',
        intro: '',
        tips: '',
        exp: null,
        expx: null,
        duration: null,
        status: 1
      }
    }
  },
  methods: {
    reset (model) {
      this.form.id = model.id || null
      this.form.type = model.type || 'study'
      this.form.num = model.num || 0
      this.form.title = model.title || null
      this.form.intro = model.intro || null
      this.form.tips = model.tips || null
      this.form.exp = model.exp || null
      this.form.expx = model.expx || null
      this.form.duration = model.duration || null
      this.form.status = model.status === undefined ? 1 : model.status
    },
    submit () {
      var params = { ...this.form, type: 'study' }
      if (this.form.id) {
        delete params.id
        return this.$http.put(this.$urls.lesson_unit_update, params, {
          params: { id: this.form.id }
        })
      } else {
        return this.$http.post(this.$urls.lesson_unit_create, params).then(data => {
          this.form.id = data.id
        })
      }
    }
  }
}
</script>
